import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { MessageResponse } from '../../entities/shared/message-response.entity';
import { BaseApi } from '../base.api';

@Injectable({
  providedIn: 'root',
})
export class GrocyCacheApi extends BaseApi {
  endpoint = 'grocy/cache';

  refresh(): Observable<MessageResponse> {
    return this.http
      .patch<MessageResponse>(this.generateUrl('refresh'), null, { headers: new HttpHeaders({ timeout: `${120000}` }) })
      .pipe(catchError(e => this.handleError(e)));
  }
}
